// Generated by Melange

import * as Caml_js_exceptions from "melange.js/caml_js_exceptions.js";
import * as Js__Js_json from "melange.js/js_json.js";
import * as Mapre_wire__Json from "../../shared/wire/json.js";
import * as Stdlib from "melange/stdlib.js";
import * as Stdlib__Float from "melange/float.js";
import * as Stdlib__String from "melange/string.js";

function initial(request_id) {
  return {
    value: "",
    provider: "boat",
    token: "",
    instabox: undefined,
    request_id,
    version: undefined,
    loading: true,
    pending: false,
    message: ""
  };
}

function limit(value) {
  if (value === "" || !Stdlib__String.for_all((function (param) {
      return !(param > 57 || param < 48);
    }), value)) {
    return;
  }
  const n = Stdlib.int_of_string_opt(value);
  if (n !== undefined && n >= 1 && n <= 10) {
    return n;
  }
  
}

function can_save(t) {
  if (!t.loading && !t.pending && t.version !== undefined && limit(t.value) !== undefined) {
    if (t.provider !== "instabox" || t.instabox !== undefined) {
      return true;
    } else {
      return t.token !== "";
    }
  } else {
    return false;
  }
}

function optional(json, key) {
  const value = Js__Js_json.decodeNumber(Mapre_wire__Json.get(json, key));
  if (value !== undefined) {
    return value | 0;
  }
  throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
      MEL_EXN_ID: Mapre_wire__Json.Invalid,
      _1: "invalid_settings_response"
    });
}

function timestamp(json, key) {
  const value = Js__Js_json.decodeNumber(Mapre_wire__Json.get(json, key));
  if (value !== undefined) {
    if (Stdlib__Float.is_finite(value) && value >= 0) {
      return value;
    }
    throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
        MEL_EXN_ID: Mapre_wire__Json.Invalid,
        _1: "invalid_settings_response"
      });
  }
  throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
      MEL_EXN_ID: Mapre_wire__Json.Invalid,
      _1: "invalid_settings_response"
    });
}

function instabox_of(json) {
  const match = Js__Js_json.decodeObject(json);
  if (match === undefined) {
    return;
  }
  const match$1 = Js__Js_json.decodeBoolean(Mapre_wire__Json.get(json, "configured"));
  if (match$1 !== undefined) {
    if (!match$1) {
      return;
    }
    const quota = Mapre_wire__Json.get(json, "quota");
    return {
      configured: true,
      hint: Mapre_wire__Json.string(json, "hint"),
      verified_at: timestamp(json, "verified_at"),
      machines: optional(quota, "machines"),
      max_machines: optional(quota, "max_machines"),
      running: optional(json, "running")
    };
  }
  throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
      MEL_EXN_ID: Mapre_wire__Json.Invalid,
      _1: "invalid_settings_response"
    });
}

function update(t, message) {
  if (/* tag */ typeof message !== "object" && typeof message !== "function") {
    switch (message) {
      case /* Loading */ 3 :
        return {
          value: t.value,
          provider: t.provider,
          token: t.token,
          instabox: t.instabox,
          request_id: t.request_id,
          version: t.version,
          loading: true,
          pending: t.pending,
          message: ""
        };
      case /* Pending */ 4 :
        return {
          value: t.value,
          provider: t.provider,
          token: t.token,
          instabox: t.instabox,
          request_id: t.request_id,
          version: t.version,
          loading: t.loading,
          pending: true,
          message: ""
        };
      default:
        return t;
    }
  } else {
    switch (message.TAG) {
      case /* Edited */ 2 :
        const request_id = message._1;
        const field = message._0;
        const t_value = t.value;
        const t_provider = t.provider;
        const t_token = t.token;
        const t_instabox = t.instabox;
        const t_version = t.version;
        const t_loading = t.loading;
        const t_pending = t.pending;
        switch (field.TAG) {
          case /* Session_limit */ 0 :
            return {
              value: field._0,
              provider: t_provider,
              token: t_token,
              instabox: t_instabox,
              request_id,
              version: t_version,
              loading: t_loading,
              pending: t_pending,
              message: ""
            };
          case /* Sandbox_provider */ 1 :
            return {
              value: t_value,
              provider: field._0,
              token: t_token,
              instabox: t_instabox,
              request_id,
              version: t_version,
              loading: t_loading,
              pending: t_pending,
              message: ""
            };
          case /* Instabox_token */ 2 :
            return {
              value: t_value,
              provider: t_provider,
              token: field._0,
              instabox: t_instabox,
              request_id,
              version: t_version,
              loading: t_loading,
              pending: t_pending,
              message: ""
            };
        }
      case /* Loaded */ 3 :
        const json = message._0;
        const version = Mapre_wire__Json.integer(json, "version");
        const value = Mapre_wire__Json.integer(json, "max_concurrent_sessions");
        const provider = Mapre_wire__Json.string(json, "sandbox_provider");
        if (version < 0 || value < 1 || value > 10) {
          throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
              MEL_EXN_ID: Mapre_wire__Json.Invalid,
              _1: "invalid_settings_response"
            });
        }
        return {
          value: String(value),
          provider,
          token: "",
          instabox: instabox_of(Mapre_wire__Json.get(json, "instabox")),
          request_id: message._1,
          version: version,
          loading: false,
          pending: false,
          message: message._2 ? "Settings saved." : ""
        };
      case /* Failed */ 4 :
        return {
          value: t.value,
          provider: t.provider,
          token: t.token,
          instabox: t.instabox,
          request_id: t.request_id,
          version: t.version,
          loading: false,
          pending: false,
          message: message._0
        };
      default:
        return t;
    }
  }
}

export {
  initial,
  limit,
  can_save,
  update,
}
/* Mapre_wire__Json Not a pure module */
